import React from 'react';
import { getConfig } from 'lib/config-deprecated';
import { useUser } from 'components/ui/UserContext';
import CorpIndex from 'react-scale/corp/browser';
import type { ICorpUserJson } from '@scale/shared/types/user';

const config = getConfig();

export default function CorpIndexVite() {
  const user = useUser();
  return <CorpIndex user={user as ICorpUserJson} config={config} />;
}
